import { DatasetUploadsPage, type DatasetUploadsPageProps } from "@/components/dataset-uploads/DatasetUploadsPage"
import { b2bSellOutConfig } from "@/lib/datasetRegistry"

// Thin config module — fully driven by `b2bSellOutConfig` (no slots needed).
// Controller renders "admin/b2b_sell_out/Uploads".
export default function AdminB2bSellOutUploads(props: Omit<DatasetUploadsPageProps, "config">) {
  return <DatasetUploadsPage config={b2bSellOutConfig} {...props} />
}
